import { createFileRoute } from "@tanstack/react-router";

import { FraudPage } from "../../../../areas/admin/fraud/FraudPage";

export const Route = createFileRoute("/app/_seller/admin/fraud")({
  component: FraudPage,
});
